import { createFileRoute } from "@tanstack/react-router";
import KontaktUmea from "@/pages/KontaktUmea";
import { buildBreadcrumbSchema, getBreadcrumbTrail, buildOfficeSchema, buildPageSchema, buildSeoHead, publicPageSeo } from "@/data/seo";

export const Route = createFileRoute("/kontakt-umea")({
  head: () =>
    buildSeoHead(publicPageSeo.kontaktUmea, [
      buildPageSchema(publicPageSeo.kontaktUmea, "ContactPage"),
      buildOfficeSchema("umea"),
      buildBreadcrumbSchema(getBreadcrumbTrail("/kontakt-umea") ?? []),
    ]),
  component: KontaktUmea,
});
